export default __webpack_public_path__ + "static/media/one-week-sprint.a75f08dc.pdf";